/**
 * Utilidades para verificar permisos de usuario
 */

/**
 * Verifica si el usuario tiene un permiso específico
 * @param {Object} me - Objeto del usuario actual (de Redux state.login.me)
 * @param {string} module - Módulo a verificar (ej: 'emergency_types', 'vehicles', 'users')
 * @param {string} action - Acción a verificar (ej: 'create', 'edit', 'delete', 'view')
 * @returns {boolean} - true si el usuario tiene el permiso, false en caso contrario
 */
export const hasPermission = (me, module, action) => {
    // Si no hay usuario, no tiene permisos
    if (!me || !me.id) {
        return false;
    }

    // Si no hay permisos definidos, denegar por defecto
    if (!me.permissions) {
        return false;
    }

    // Verificar si el módulo existe en los permisos
    if (!me.permissions[module]) {
        return false;
    }

    // Verificar si la acción específica está permitida
    return me.permissions[module][action] === true;
};

/**
 * Verifica si el usuario puede crear en un módulo
 * @param {Object} me - Objeto del usuario actual
 * @param {string} module - Módulo a verificar
 * @returns {boolean}
 */
export const canCreate = (me, module) => hasPermission(me, module, 'create');

/**
 * Verifica si el usuario puede editar en un módulo
 * @param {Object} me - Objeto del usuario actual
 * @param {string} module - Módulo a verificar
 * @returns {boolean}
 */
export const canEdit = (me, module) => hasPermission(me, module, 'edit');

/**
 * Verifica si el usuario puede eliminar en un módulo
 * @param {Object} me - Objeto del usuario actual
 * @param {string} module - Módulo a verificar
 * @returns {boolean}
 */
export const canDelete = (me, module) => hasPermission(me, module, 'delete');

/**
 * Verifica si el usuario puede ver en un módulo
 * @param {Object} me - Objeto del usuario actual
 * @param {string} module - Módulo a verificar
 * @returns {boolean}
 */
export const canView = (me, module) => hasPermission(me, module, 'view');

/**
 * Verifica si el usuario es administrador
 * @param {Object} me - Objeto del usuario actual
 * @returns {boolean}
 */
export const isAdmin = (me) => {
    const ROLE_ADMIN = 1;
    return me && me.role === ROLE_ADMIN;
};

/**
 * Nombres de módulos para usar con las funciones de permisos
 */
export const MODULES = {
    EMERGENCY_TYPES: 'emergency_types',
    EMERGENCIES: 'emergencies',
    VEHICLES: 'vehicles',
    VEHICLE_TYPES: 'vehicle_types',
    USERS: 'users',
    ROLES: 'roles',
    STATIONS: 'stations',
    QR_SCAN: 'qr_scan',
    TRACKING: 'tracking',
    BINNACLE: 'binnacle',
    HUMAN_RESOURCES: 'human_resources',
    REPORTS: 'reports',
    SETTINGS: 'settings',
};
